export default __webpack_public_path__ + "static/media/menu.bd5a85d2.svg";